import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

interface PageLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, title, subtitle, icon, actions }) => (
  <div style={{ background: 'var(--nx-surface-2)', minHeight: '100vh', fontFamily: 'var(--font-body)' }}>
    <Navbar variant="dashboard" />
    <Sidebar />
    <main style={{ marginLeft: 220, marginTop: 60, padding: '28px 28px 40px', minHeight: 'calc(100vh - 60px)' }}>
      {title && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {icon}
            <div>
              <h1 style={{ fontFamily: 'Syne, sans-serif', fontSize: 22, fontWeight: 700, color: 'var(--nx-text-primary)', letterSpacing: '-0.03em', marginBottom: 4 }}>
                {title}
              </h1>
              {subtitle && <p style={{ fontSize: 13, color: 'var(--nx-text-muted)' }}>{subtitle}</p>}
            </div>
          </div>
          {actions}
        </div>
      )}
      {children}
    </main>
  </div>
);

export default PageLayout;
